import { Request } from '../../../httpClient/serverApi/requests/Request';
import { SubscriptionFlow } from '../types/SubscriptionFlow';

export interface GetRunFlowTaskSubscriptionFlowParams {
    taskId: string;
}

export interface GetRunFlowTaskSubscriptionFlowResult {
    readonly subscriptionFlow: SubscriptionFlow;
    readonly sendEmailWhenDone: boolean;
}

export class GetRunFlowTaskSubscriptionFlowRequest extends Request<GetRunFlowTaskSubscriptionFlowParams, GetRunFlowTaskSubscriptionFlowResult> {
  constructor(taskId: string) {
    super('getRunFlowTaskSubscriptionFlow', { taskId: taskId });
  }
}